<div class="container-fluid py-4">
  <div class="row justify-content-center">
    <div class="col-4 col-md-2" *ngFor="let card of resumenCards; index as i">
      <div
        class="card card-stats"
        [ngClass]="{ 'card-stats__selected': i === 2 }"
        [routerLink]="card.route"
        [style.cursor]="card.route ? 'pointer' : 'default'"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-7 col-lg-6">
              <div
                class="icon-big text-center text-dark rounded shadow"
                [ngClass]="card.bgClass"
              >
                <i [class]="card.icon"></i>
              </div>
            </div>
            <div class="col-7 d-flex flex-column justify-content-center">
              <p class="card-category mb-0">{{ card.label }}</p>
              <h4
                class="card-title mb-0"
                [ngClass]="{ 'text-dark': i === 2, 'text-white': i !== 2 }"
              >
                {{ card.value }}
              </h4>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="stats">
            <small [class]="i == 2 ? 'desc__selected' : 'desc'">{{
              card.desc
            }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mb-6 mt-4">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <div class="flex-grow-1 text-center">
        <a
          class="btn btn-dark btn-sm btn-new"
          routerLink="/marketing/social/contentRequests"
          >Content Requests
        </a>
        <a
          class="btn btn-dark btn-sm btn-reg"
          routerLink="/marketing/social/registry"
          >Social Registry
        </a>
      </div>

    </div>
  </div>

  <div class="row mb-6 mt-4 text-center">
    <div class="col-12">
      <button
        class="btn btn-sm mx-1 btn-platform"
        [ngClass]="
          filters.platform === 'instagram'
            ? 'btn-platform-selected'
            : 'btn-platform'
        "
        (click)="filters.platform = filters.platform === 'instagram' ? '' : 'instagram'; applyFilters()"
      >
        Instagram
      </button>
      <button
        class="btn btn-sm mx-1 btn-platform"
        [ngClass]="
          filters.platform === 'facebook'
            ? 'btn-platform-selected'
            : 'btn-platform'
        "
        (click)="filters.platform = filters.platform === 'facebook' ? '' : 'facebook'; applyFilters()"
      >
        Facebook
      </button>
      <button
        class="btn btn-sm mx-1 btn-platform"
        [ngClass]="
          filters.platform === 'linkedin'
            ? 'btn-platform-selected'
            : 'btn-platform'
        "
        (click)="filters.platform = filters.platform === 'linkedin' ? '' : 'linkedin'; applyFilters()"
      >
        LinkedIn
      </button>
      <button
        class="btn btn-sm mx-1 btn-platform"
        [ngClass]="
          filters.platform === 'youtube'
            ? 'btn-platform-selected'
            : 'btn-platform'
        "
        (click)="filters.platform = filters.platform === 'youtube' ? '' : 'youtube'; applyFilters()"
      >
        Youtube
      </button>
    </div>
  </div>

  <div class="card shadow-sm mb-4 mt-4">
    <div class="card-body">
      <div class="row g-3">
        <div class="col-md-2">
          <label class="form-label small fw-bold">Status</label>
          <select
            class="form-select form-select-sm"
            [(ngModel)]="filters.status"
            (change)="applyFilters()"
          >
            <option value="">All</option>
            <option value="draft">Draft</option>
            <option value="approved">Approved</option>
            <option value="scheduled">Scheduled</option>
            <option value="published">Published</option>
            <option value="archived">Archived</option>
          </select>
        </div>

        <div class="col-md-2">
          <label class="form-label small fw-bold">Vertical</label>
          <select
            class="form-select form-select-sm"
            [(ngModel)]="filters.vertical"
            (change)="applyFilters()"
          >
            <option value="">All</option>
            <option value="courier">Courier</option>
            <option value="task_runner">Task Runner</option>
          </select>
        </div>

        <div class="col-md-2">
          <label class="form-label small fw-bold">Scheduled</label>
          <select
            class="form-select form-select-sm"
            [(ngModel)]="filters.scheduled"
            (change)="applyFilters()"
          >
            <option value="">All</option>
            <option value="false">Not Scheduled</option>
          </select>
        </div>

        <div class="col-md-4 d-flex align-items-end justify-content-end gap-2">
          <div class="input-group input-group-sm">
            <input
              type="text"
              class="form-control"
              placeholder="Asset ID or Title..."
              [(ngModel)]="searchText"
              (ngModelChange)="applyFilters()"
              list="suggestionsRegistry"
              autocomplete="off"
            />
            <span class="input-group-text"><i class="fas fa-search"></i></span>
          </div>
          <datalist id="suggestionsRegistry">
            <option
              *ngFor="let suggestion of searchSuggestions"
              [value]="suggestion"
            ></option>
          </datalist>
        </div>
      </div>
    </div>
  </div>

  <div class="card shadow-sm">
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead class="thead">
            <tr>
              <th>Asset ID</th>
              <th>Title</th>
              <th>Platform</th>
              <th>Type</th>
              <th>Status</th>
              <th>Vertical</th>
              <th>Scheduled</th>
              <th>Published</th>
              <th>Impressions</th>
              <th>Engagement</th>
              <th class="text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of filteredData">
              <td
                class="url-cell"
                (click)="showModal('Asset ID', item.social_asset_id)"
                title="Click to view full Asset ID"
              >
                <span class="fw-bold">{{ item.social_asset_id }}</span>
              </td>
              <td class="general-cell">{{ item.title_internal }}</td>
              <td>
                <span class="badge badge-info">{{
                  item.platform | uppercase
                }}</span>
              </td>
              <td>{{ item.asset_type | uppercase }}</td>
              <td>
                <span
                  class="badge w-100"
                  [ngClass]="{
                    'badge-secondary': item.status === 'draft',
                    'badge-primary': item.status === 'approved',
                    'badge-info': item.status === 'scheduled',
                    'badge-success': item.status === 'published',
                    'badge-danger': item.status === 'archived',
                  }"
                >
                  {{ item.status | uppercase }}
                </span>
              </td>
              <td>{{ item.vertical | uppercase }}</td>
              <td>{{ item.scheduled_at | date: "shortDate" }}</td>
              <td>{{ item.published_at | date: "shortDate" }}</td>
              <td>{{ item.impressions }}</td>
              <td>{{ item.engagement_rate }}%</td>
              <td class="text-center">
                <div class="d-flex justify-content-center align-items-center">
                  <a
                    class="btn btn-link text-dark btn-sm"
                    [routerLink]="['/marketing/social/registry/edit', item._id]"
                    title="Edit"
                  >
                    <i class="fas fa-pen"></i>
                  </a>

                  <button
                    *ngIf="isItemComplete(item)"
                    (click)="approveItem(item._id)"
                    class="btn btn-link text-success btn-sm"
                    title="Approve"
                  >
                    <i class="fas fa-check-circle"></i>
                  </button>

                  <button
                    (click)="deleteData(item._id)"
                    class="btn btn-link text-danger btn-sm"
                    title="Delete"
                  >
                    <i class="fas fa-trash"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal-url-overlay" *ngIf="modalContent" (click)="closeModal()">
  <div class="modal-url-content" (click)="$event.stopPropagation()">
    <div class="modal-url-header">
      <h5 class="mb-0">{{ modalTitle }}</h5>
      <button type="button" class="modal-url-close" (click)="closeModal()">
        &times;
      </button>
    </div>
    <div
      class="modal-url-body text-dark"
      style="word-wrap: break-word; white-space: pre-wrap"
    >
      {{ modalContent }}
    </div>
  </div>
</div>
